<template>
  <div class="flex flex-col gap-24">
    <H1 class="font-semibold">
      {{ $t('health_actions.scheduling.contact_health_plan_title') }}
    </H1>
    <H2 class="font-semibold">
      {{ $t('health_actions.scheduling.contact_health_plan_description') }}
    </H2>
    <img
      src="../../../../../assets/images/Schedule_Success.png"
      alt="Schedule Success"
      class="mx-auto mb-14 mt-8 sm:mt-0"
    />
    <HMButton class="self-center" @click="$router.back()">{{
      $t('health_actions.scheduling.schedule_success_return_btn')
    }}</HMButton>
  </div>
</template>

<script>
import H1 from '~/components/common/Typography/H1.vue'
import H2 from '~/components/common/Typography/H2.vue'

export default {
  components: {
    H1,
    H2,
  },
}
</script>
